import { MantineProvider } from "@mantine/core";
import type { ReactNode } from "react";

import { prefsColorSchemeManager } from "../color-scheme";
import { theme } from "../theme";
import { useThemeFamily } from "./current";
import { cssVariablesResolverFor } from "./resolver";

const colorSchemeManager = prefsColorSchemeManager();

/**
 * Mantine with the shown theme family in its two colour scheme slots (spec web/themes-engine).
 * Light or dark is still the header's sun or moon, stored as before; a family only changes which
 * light and which dark the app shows.
 */
export function ThemeProvider({
  env,
  cssVariables = env !== "test",
  children,
}: {
  /** "test" turns off Mantine's transitions and portals, and by default its CSS variables. */
  env: "default" | "test";
  /**
   * Whether Mantine writes the CSS variables. Off in tests by default: jsdom resolves their sheet
   * on every computed style (spec editor-test-speed); the theme's own tests turn them on.
   */
  cssVariables?: boolean;
  children: ReactNode;
}) {
  const family = useThemeFamily();
  return (
    <MantineProvider
      theme={theme}
      cssVariablesResolver={cssVariablesResolverFor(family)}
      colorSchemeManager={colorSchemeManager}
      defaultColorScheme="light"
      env={env}
      withCssVariables={cssVariables}
    >
      {children}
    </MantineProvider>
  );
}
